import { jsonldJobTitle } from './JsonldStore';

export const updateJsonldJobTitle = (value) => jsonldJobTitle.update((oldValue) => value);
